export default __webpack_public_path__ + "static/m-banh5-df9df62d8a6e72c8a43c6e0ee91e211e.jpg";